var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-info-container',{staticClass:"basket-deliverytype"},[_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t(`${_vm.tPath}.title`)))]),_c('hr',{staticClass:"mb-3"}),_c('b-form-radio-group',{attrs:{"options":_vm.options},on:{"change":_vm.setDeliveryType},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }